export default Object.freeze({
  apm: Object.freeze({
    service: '0000a000-9e6b-4e7c-85d0-e0f691fc415c',
    characteristics: Object.freeze({
      WRITE: '0000b010-9e6b-4e7c-85d0-e0f691fc415c',
      INDICATION: '0000b020-9e6b-4e7c-85d0-e0f691fc415c',
    }),
  })
})
